import type { WorkspaceMember as GraftWorkspaceMember } from '@graft/nuget-gc.webportals.workspaces'

import { readGraftObject } from '@common/utils/readGraftObject'

import type { WorkspaceMember as WorkspaceMemberPlain } from '@modules/workspaces/workspaces.type'

import { MemberLevel, MemberStatus } from '../../enums'
import type { WorkspaceMember } from '../../settings.interface'

export async function workspaceMemberToObject(entity: GraftWorkspaceMember): Promise<WorkspaceMember> {
  const dto = await readGraftObject<WorkspaceMemberPlain>(entity)

  const nameParts = [dto.firstName, dto.lastName].flatMap((part) => {
    const trimmed = part?.trim()
    return trimmed ? [trimmed] : []
  })
  const name = nameParts.length ? nameParts.join(' ') : null
  const emailValue = dto.email ?? ''
  const id = dto.userId || emailValue || `workspace-member-${name ?? 'unknown'}`
  const role = dto.level === MemberLevel.ADMIN ? MemberLevel.ADMIN : MemberLevel.DEVELOPER

  return {
    id,
    name,
    email: emailValue,
    avatarUrl: dto.avatarUrl?.trim() || null,
    role,
    status: MemberStatus.ACTIVE,
    lastSeen: null,
    projectIds: [],
    projectsCount: dto.projectsCount,
  }
}
